<template>
  <v-dialog v-model="dialog" persistent width="950">

    <v-card class="p-0">
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>visibility</v-icon>
          Ver detalle
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md style="min-width: 100%">
          <v-layout wrap row>
            <v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Gestión: </strong> {{ form.gestion }}
              </h3>
            </v-flex>
            <v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Fecha de creación: </strong>
                {{ $moment(form.fecha_creacion).format("DD-MM-YYYY") }}
              </h3>
            </v-flex>
            <v-flex xs12 md12>
              <h3 class="detalle" v-if="form.fecha_aprobacion">
                <strong>Fecha de aprobación:</strong>
                {{ $moment(form.fecha_aprobacion).format("DD-MM-YYYY") }}
              </h3>
            </v-flex>
            <v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Fecha de ejecución:</strong>
                {{ $moment(form.fecha_ejecucion).format("DD-MM-YYYY") }}
              </h3>
            </v-flex>
          </v-layout>
          <h3 class="detalleSubtitulo"><strong>Listado de incrementos salariales</strong></h3>
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="incremento_salarial_detalles"
                class="elevation-1"
                :headers="headers_detalles"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.cargo }}
                  </td>
                  <td class="text-xs-center">{{ props.item.porcentaje }}</td>
                  <td class="text-xs-center">
                    {{ props.item.haber_basico_actual }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.haber_basico_incrementado }}
                  </td>
                  <td class="text-xs-center">
                    
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <h3 class="detalleSubtitulo"><strong>Seguimiento de registro</strong></h3>
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="seguimientos"
                class="elevation-1"
                :headers="headers_seguimientos"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_registro }}
                  </td>
                  <td class="text-xs-center">{{ props.item.nombres }}</td>
                  <td class="text-xs-center">
                    {{ props.item.estado }}
                  </td>
                
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn @click.native="close()"> <v-icon>cancel</v-icon> CERRAR </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
  
  <script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones


export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      lista_cargos: [],
      seguimientos: [],
      headers_seguimientos: [
        { text: "Fecha", value: "fecha_registro", align: "center" },
        { text: "Usuario", value: "nombres", align: "center" },
        {
          text: "Estado",
          value: "estado",
          align: "center",
        },
      ],
      incremento_salarial_detalles: [],
      id_incremento_salarial: null,
      bandera_id_incremento: false,
      headers_detalles: [
        { text: "Cargo", value: "cargo", align: "center" },
        { text: "Porcentage", value: "porcentage", align: "center" },
        {
          text: "Haber básico actual",
          value: "haber_basico_actual",
          align: "center",
        },
        {
          text: "Haber básico incrementado",
          value: "haber_basico_incrementado",
          align: "center",
        },
      ],
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerIncremento", async (item) => {
      this.form = item;
      await this.cargarSeguimiento();
      if (this.form.id_incremento) {
        this.id_incremento_salarial = this.form.id_incremento;
        this.bandera_id_incremento = true;
        await this.cargarIncrementoSalarialDetalle(this.form.id_incremento);
      }
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.form = {};
      this.loading = false;
      this.incremento_salarial_detalles = [];
      this.valid = false;
      this.$bus.$emit("closeDialogVerIncremento");
      this.dialog = false;
    },
    async eliminarIncremento(dato) {
      try {
        this.$confirm("Desea eliminar el registro?", async () => {
          let usuario = this.$storage.get("user");
          let respuesta = await this.$service.graphql({
            query: `
                            query{
                              runQuery(consulta:"select movilidad.fn_elimina_incremento_salarial_detalle(${parseInt(
                                dato.id_incremento_salarial_detalle
                              )},${dato.id_cargo},${usuario.id})"){
                              respuesta
                              }
                            }
                          `,
          });
          respuesta =
            respuesta.runQuery.respuesta[0]
              .fn_elimina_incremento_salarial_detalle;
          let resps = respuesta.split("|");
          if (resps[0] == "1") {
            this.$message.info("Registro eliminado exitosamente");
            await this.cargarIncrementoSalarialDetalle(this.form.id_incremento);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
  async cargarSeguimiento() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
				query {
					runQuery(consulta:"select * from movilidad.v_seguimiento_incremento_salarial vs where vs.id_estado <> 2 and vs.id_incremento_salarial=${parseInt(this.form.id_incremento)}"){
						respuesta
					}
					}
				`,
        });
        this.seguimientos = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },

    async cargarIncrementoSalarialDetalle(id) {
      try {
        this.incremento_salarial_detalles = [];
        let respuesta = await this.$service.graphql({
          query: `
                  query {
                      runQuery(consulta:"select * from movilidad.v_incremento_salarial_detalle vis where vis.id_incremento_salarial=${parseInt(
                        id
                      )} and vis.id_estado_incremento_salarial_detalle<>2"){
                          respuesta
                      }
                      }
                  `,
        });
        this.incremento_salarial_detalles = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerGestion() {
      try {
        console.log("-+++++", this.form.fecha_ejecucion.length);
        if (
          this.form.fecha_ejecucion &&
          this.form.fecha_ejecucion.length == 10
        ) {
          let año = parseInt(this.form.fecha_ejecucion.substring(0, 4));
          console.log(año, "-9-9-9-9--");
          this.form.gestion = año;
        }
        if (this.form.fecha_ejecucion.length > 10) {
          this.$message.info("Fecha no valida");
          return;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async adicionarDetalle() {
      try {
        if (this.$refs.form.validate()) {
          let usuario = this.$storage.get("user");
          let correcto;

          if (this.incremento_salarial_detalles.length < 1) {
            let respuesta = await this.$service.graphql({
              query: `
                            query{
                              runQuery(consulta:"select movilidad.fn_registra_incremento_salarial(${parseInt(
                                this.form.gestion
                              )},'${this.form.fecha_ejecucion}',${
                usuario.id
              })"){
                              respuesta
                              }
                            }
                          `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_registra_incremento_salarial;
            let resps = respuesta.split("|");
            correcto = resps[0];
            this.id_incremento_salarial = resps[1];

            if (correcto != "1") {
              this.$message.warnings(resps[1]);
              return;
            }
          } else {
            //modificando la cabecera:
            let resps1;
            let respuesta2 = await this.$service.graphql({
              query: `
                              query{
                                runQuery(consulta:"select movilidad.fn_actualiza_incremento_salarial_cabecera(${parseInt(
                                  this.id_incremento_salarial
                                )},${parseInt(this.form.gestion)},'${
                this.form.fecha_ejecucion
              }',${usuario.id})"){
                                respuesta
                                }
                              }
                            `,
            });
            respuesta2 =
              respuesta2.runQuery.respuesta[0]
                .fn_actualiza_incremento_salarial_cabecera;
            resps1 = respuesta2.split("|");

            if (resps1[0] != "1") {
              this.$message.warnings(resps1[1]);
              return;
            }
          }
          //almacenando los detalles
          let rpta = await this.$service.graphql({
            query: `
                            query{
                              runQuery(consulta:"select movilidad.fn_registra_incremento_salarial_detalle(${parseInt(
                                this.id_incremento_salarial
                              )},${parseInt(this.form.id_cargo)},'${
              this.form.haber_incrementado
            }','${this.form.incremento_porcentaje}',${usuario.id})"){
                              respuesta
                              }
                            }
                          `,
          });
          rpta =
            rpta.runQuery.respuesta[0].fn_registra_incremento_salarial_detalle;
          let resps = rpta.split("|");
          if (resps[0] == "1") {
            this.$confirm("Registro exitoso");
            await this.cargarIncrementoSalarialDetalle(
              this.id_incremento_salarial
            );
            this.bandera_id_incremento = true;
            this.form.id_cargo = null;
            this.form.incremento_porcentaje = null;
            this.form.haber_actual = null;
            this.form.haber_incrementado = null;
          } else {
            this.$confirm(resps[1]);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async cargarHaber() {
      try {
        let nuevo_haber;
        if (this.form.id_cargo) {
          const haber_actual = this.lista_cargos.find(
            (fruta) => fruta.id_cargo == parseInt(this.form.id_cargo)
          ).sueldo;
          this.form.haber_actual = parseFloat(
            haber_actual.replace(/\./g, "").replace(/\,/g, ".")
          );
        }
        if (this.form.haber_actual && this.form.incremento_porcentaje) {
          nuevo_haber =
            (this.form.incremento_porcentaje / 100) * this.form.haber_actual +
            this.form.haber_actual;
          this.form.haber_incrementado = nuevo_haber;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  components: {
  
  },
};
</script>
  
  <style>
.detalle {
  font-size: 1.07em;
  color: rgb(24, 22, 134);
}
.detalleSubtitulo {
  font-size: 1.45em;
  color: rgb(24, 22, 134);
}
</style>
  


// WEBPACK FOOTER //
// src/components/admin/incremento_salarial/dialogs/VerRegistro.vue